import React, { useId, useState } from 'react';
import { useTranslations } from '@unisporkal/localization';
import {
  Typography,
  TypographyComponentEnum,
  TypographyVariant,
} from '@unisporkal/alliance-ui';
import { AiGeneratorIcon, ThumbUp, CaretDown, CaretUp } from '../support/icons';
import styles from '../ModifiedBuyCard.module.scss';

interface WhatToExpectProps {
  sizeName: string;
  // ilox keys for each line; index 0 = AI paragraph, index 1 = "Best for…".
  itemKeys: string[];
}

// One icon per "what to expect" line: the AI paragraph, then the "Best for…"
// thumb line. Extra keys (defensive) reuse the thumb icon.
const ICONS = [AiGeneratorIcon, ThumbUp];

const WhatToExpect = ({ sizeName, itemKeys }: WhatToExpectProps) => {
  const t = useTranslations();
  const [open, setOpen] = useState(false);
  const bodyId = useId();

  return (
    <div className={styles.whatToExpect}>
      <button
        type="button"
        className={styles.whatToExpectToggle}
        aria-expanded={open}
        aria-controls={bodyId}
        data-testid={`what-to-expect-toggle-${sizeName}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <Typography
          component={TypographyComponentEnum.SPAN}
          variant={TypographyVariant.body.xsmall}
        >
          {t('what_to_expect')}
        </Typography>
        {open ? (
          <CaretUp className={styles.toggleCaret} />
        ) : (
          <CaretDown className={styles.toggleCaret} />
        )}
      </button>
      {open && (
        <div
          id={bodyId}
          className={styles.whatToExpectList}
          data-testid={`what-to-expect-${sizeName}`}
        >
          {itemKeys.map((key, index) => {
            const Icon = ICONS[index] || ThumbUp;
            return (
              <div
                key={key}
                className={styles.whatToExpectItem}
              >
                <Icon className={styles.whatToExpectItemIcon} />
                <Typography
                  component={TypographyComponentEnum.SPAN}
                  variant={TypographyVariant.body.xsmall}
                >
                  {t(key)}
                </Typography>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default WhatToExpect;
